import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWip"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2V4H16V2H18V4H22V14H18V20H19V22H15V20H16V14H8V20H9V22H5V20H6V14H2V4H6V2H8ZM17.0274 12L20.2315 6H17.9725L14.7684 12H17.0274ZM9.23155 6L6.02744 12H3.76843L6.97254 6H9.23155ZM9.26843 12H11.5274L14.7315 6H12.4725L9.26843 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWip;
